import React from 'react';
import { Button, Group } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IconArrowLeft } from '@tabler/icons-react';

/** Страница ошибки с выходом: «Назад» и «На дашборд», чтобы не упираться в тупик. */
const ErrorPage: React.FC<{ code: 403 | 404; color: string }> = ({ code, color }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: 'calc(100vh - 100px)',
        textAlign: 'center',
        padding: '2rem',
      }}
    >
      <h1 style={{ fontSize: '4rem', margin: 0, color }}>{code}</h1>
      <h2 style={{ margin: '1rem 0' }}>{t(`error${code}.title`)}</h2>
      <p style={{ color: '#868e96', maxWidth: '440px' }}>{t(`error${code}.description`)}</p>
      <Group mt="md">
        {window.history.length > 1 && (
          <Button
            variant="light"
            leftSection={<IconArrowLeft size={16} />}
            onClick={() => navigate(-1)}
          >
            {t('common.back')}
          </Button>
        )}
        <Button onClick={() => navigate('/dashboard')}>{t('errors.toDashboard')}</Button>
      </Group>
    </div>
  );
};

export const Error403: React.FC = () => <ErrorPage code={403} color="#fa5252" />;
export const Error404: React.FC = () => <ErrorPage code={404} color="#fab005" />;
